module.exports = __webpack_public_path__ + "img/contract_icon.aafaa0a5.png";